/*
,------.                                    ,--.          ,--.      ,--------.    ,------.            ,--.           
|  .-.  \,--. ,--.,--,--,  ,--,--.,--,--,--.`--' ,---.    |  | ,---.'--.  .--'    |  .-.  \  ,--,--.,-'  '-. ,--,--. 
|  |  \  :\  '  / |      \' ,-.  ||        |,--.| .--'    |  || .-. |  |  |       |  |  \  :' ,-.  |'-.  .-'' ,-.  | 
|  '--'  / \   '  |  ||  |\ '-'  ||  |  |  ||  |\ `--.    |  |' '-' '  |  |       |  '--'  /\ '-'  |  |  |  \ '-'  | 
`-------'.-'  /   `--''--' `--`--'`--`--`--'`--' `---'    `--' `---'   `--'       `-------'  `--`--'  `--'   `--`--' 
         `---'                                                                                                      
*/

import { BaseService } from './base';
import { AddressInformation } from './latest';

export interface IdleDTO {
    id: string;
    assetId: string;
    latitude: number;
    longitude: number;
    durationSeconds: number;
    startTimeUTC: number;
}

export interface TripDTO {
    id: string; // ID of the trip
    assetId: string; // ID of the asset

    startTimeUTC: number; // Start timestamp of the trip.
    startAddress: AddressInformation;

    endTimeUTC: number; // End timestamp of the trip.
    endAddress: AddressInformation;

    distanceKm: number; // Total distance of the trip.
    coordinates: [number, number][];
    idles: IdleDTO[];
}

/** Trip Service class to handle communication with the backend API for trip-related operations.
 *
 */
export class TripService extends BaseService {
    init() {
        return new Promise((resolve, _reject) => {
            console.log('Trip Service Loaded');
            resolve('Loaded');
        });
    }

    /** Fetch trip data for the specified time range and assets.
     *
     * @param start Start timestamp in UTC long format.
     * @param end  End timestamp in UTC long format.
     * @param assets Comma-separated list of asset IDs to fetch trip data for.
     * @returns Promise that resolves to an array of TripDTO objects containing trip details for the specified assets and time range.
     */
    async fetchTripData(start: string, end: string, assets: string[]) {
        const response = await this.post<TripDTO[]>(this.url + '/api/' + this.orgid + '/trip?start=' + start + '&end=' + end, assets);
        return response;
    }
}
